import { KeyboardEvent } from "react";

export function getClickableProps(onClick: () => void, onDoubleClick?: () => void) {
  return {
    tabIndex: 0,
    role: "button" as const,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onDoubleClick ? onDoubleClick() : onClick();
      }
    }
  };
}
